import { createGlobalStyle } from 'styled-components'

const GlobalStyle = createGlobalStyle`
  li {
      list-style: none;
  }
  * {
    margin: 0;
    padding: 0;
    font-family: inherit;
    box-sizing: border-box;
    font-family: 'NeueHaasGroteskTextPro', sans-serif;
    font-weight: 400;
  }
  html, body {
    height: 100%;
    background-color: #000;
  }
  body {
    width: 100%;
    position: relative;
  }
`

export default GlobalStyle
